import { Link } from "react-router-dom";

function FinishScreen({ answers, questions, dispatch }) {
  const messages = [];
  let allYes = true;

  answers.forEach((answerIndex, questionIndex) => {
    const question = questions[questionIndex];
    const selectedOption = question.options[answerIndex];

    if (selectedOption === "No" || selectedOption === "Not sure") {
      allYes = false;

      if (questionIndex === 0) {
        messages.push(
          "It seems you do not have a smart lock or deadbolt installed on your front door. 26.5% of break-ins happen by forcing or breaking doors. We recommend installing a smart lock or deadbolt."
        );
      }

      if (questionIndex === 1) {
        messages.push(
          "You do not have window sensors or cameras installed to monitor your windows. 18.3% of break-ins occur through windows. We recommend adding window sensors or security cameras."
        );
      }

      if (questionIndex === 2) {
        messages.push(
          "You do not have security cameras installed at the back of your home. 24.4% of break-ins occur through back entrances. We recommend placing a camera at the back of your home."
        );
      }

      if (questionIndex === 3) {
        messages.push(
          "You do not have a fire alarm system installed. We recommend installing an alarm system for comprehensive home security."
        );
      }
    }
  });

  return (
    <div className="finish-screen-container">
      <div className="result-messages">
        {messages.length > 0 ? (
          <>
            {messages.map((message, index) => (
              <p key={index} className="result">
                {message}
              </p>
            ))}
            <p className="conclusion">
              Based on your responses, we recommend adding the above security
              measures to improve your home safety. You can use our 3D model to
              see the best locations for installing these devices in your home.
            </p>
          </>
        ) : (
          <p className="result">
            You already have basic security measures in place, which is great!
            If you want to double-check the optimal placement of your devices,
            you can still use our 3D model to visualize the best locations.
          </p>
        )}
      </div>
      <div className="finish-buttons">
        <Link to="/model" style={{ textDecoration: "none" }}>
          <button className="btn btn-ui">View Model</button>
        </Link>
        <button
          className="btn btn-ui"
          onClick={() => dispatch({ type: "restart" })}
        >
          Try Again
        </button>
      </div>
    </div>
  );
}

export default FinishScreen;
